import { Component } from '@angular/core';
import { UserService } from './services/user.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'admin';

  logged$: Observable<boolean>;
  logged: boolean = false

  constructor(private modelService: UserService, private route: Router) { }

  ngOnInit() {
    this.logged$ = this.modelService.getLogin$();
    this.logged$.subscribe(val => this.logged = val);

    this.checkLogin();

  }

  checkLogin() {
    this.modelService.checkLogin()
  }
}
